import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 

 
class BlogInfoContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            blogs : [],
            blog_info : [],
            loading : 1 
        }
    }
 
    componentDidMount()
    {
         this.setState({loading:0});
       
    } 


    render()
    { 
        
        if (this.state.loading == 1) {
            return <div>Loading...</div>;
          }
    return (
        
      <div>
  <section className="section-padded">
    <h2
      className="content"
      style={{
        fontSize: "30px",
        fontWeight: 200,
        color: "var(--main-blue)",
        textTransform: "uppercase",
      }}
    >
      {this.props.blog.title}
    </h2>
  </section>

  <section className="section-padded">
    <div className="content">
      <div
        dangerouslySetInnerHTML={{ __html: this.props.blog.description }}
      />
    </div>
  </section>
  <div class="space"></div>
</div>

    );
}

}

export default BlogInfoContent;